import { Combobox } from '@/components/ui/combobox/combobox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import HotkeyDialogBoxes from '@/components/ux/all-list-and-board/hotkey-dialog-boxes';
import type { HotkeyDialogBox } from '@/components/ux/all-list-and-board/use-all-list-and-board-hotkeys';
import HotKeyListener from '@/components/ux/hot-key-listener';
import { useDealActions } from '@/hooks/use-deal-actions.tsx';
import { toast } from '@/hooks/use-toast';
import { HOTKEYS } from '@/lib/hotkeys';
import type { Deal } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import LenderDialog from '../lenders/lender-dialog';
import TradeInEditDialog from '../trade/trade-in-edit-dialog';
import DealMenuButton from './deal-menu-button';

const MobileDealMenu = observer(
  ({
    deal,
    withHokeyListener = false,
  }: {
    deal: Deal;
    withHokeyListener?: boolean;
  }) => {
    const [open, setOpen] = useState(false);
    const [tradeIn, setTradeIn] = useState<Deal['trades'][0] | null>(null);
    const [openDialog, setOpenDialog] = useState<HotkeyDialogBox | null>(null);
    const [createLenderDialogIsOpen, setCreateLenderDialogIsOpen] =
      useState(false);

    const { dealActions, handleAction, handleCreateLender } = useDealActions({
      deal,
      dealShortId: deal.short_id ?? '',
      setOpenDialog,
      setTradeIn,
      setCreateLenderDialogIsOpen,
    });

    return (
      <div>
        <DealMenuButton onClick={() => setOpen(true)} />
        <Dialog open={open} onOpenChange={setOpen} modal>
          <DialogContent onClickClose={() => setOpen(false)}>
            <DialogTitle></DialogTitle>
            <DialogDescription>
              <Combobox
                endAdornment={undefined}
                placeholder={'Filter deal actions...'}
                emptyMessage={'No actions found'}
                options={dealActions.map((action) => ({
                  label: action.label,
                  value: action.value,
                  icon: action.icon,
                }))}
                onChange={handleAction}
                setOpen={setOpen}
              ></Combobox>
            </DialogDescription>
          </DialogContent>
        </Dialog>
        {tradeIn && (
          <TradeInEditDialog
            dealId={deal.id}
            tradeIn={tradeIn}
            dialogIsOpen={!!tradeIn}
            setDialogIsOpen={(open) => {
              if (!open) {
                setTradeIn(null);
              }
            }}
            onSuccess={() => {
              toast({
                title: `Trade-in successfully updated`,
              });
            }}
            onError={(error) => {
              toast({
                title: `Error updating trade-in`,
                description: error.message,
              });
            }}
          ></TradeInEditDialog>
        )}
        {handleCreateLender && (
          <LenderDialog
            initialName={''}
            initialEmail={''}
            initialPhone={''}
            initialLenderType={'bank'}
            onClickCta={handleCreateLender}
            ctaText={'Create Lender'}
            onOpen={() => setCreateLenderDialogIsOpen(true)}
            onClose={() => setCreateLenderDialogIsOpen(false)}
            dialogIsOpen={createLenderDialogIsOpen}
          ></LenderDialog>
        )}
        <HotkeyDialogBoxes
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedDeal={deal}
        />
        {withHokeyListener && (
          <HotKeyListener
            hotkeys={HOTKEYS.DEAL_DEAL_MENU}
            onHotkeyPressed={() => {
              setOpen(true);
            }}
          />
        )}
      </div>
    );
  },
);

export default MobileDealMenu;
